import { render, staticRenderFns } from "./TypeProfileForm.vue?vue&type=template&id=ea8c9060&"
import script from "./TypeProfileForm.vue?vue&type=script&lang=js&"
export * from "./TypeProfileForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports